module.exports = "/images/GC-What we do-02.jpg";